export default {

  android: (typeof window.AndroidWrapper !== 'undefined' ? {
    getFcmToken: () => {
      console.info('Getting FCM token from AndroidWrapper')
      if (typeof window.AndroidWrapper.getFcmToken === 'function') {
        return window.AndroidWrapper.getFcmToken()
      }
      return null
    },
    shareContent: (shareOpts) => {
      console.info('Sharing content via AndroidWrapper')
      if (typeof window.AndroidWrapper.shareContent === 'function') {
        window.AndroidWrapper.shareContent(shareOpts.url, shareOpts.title, shareOpts.poster)
      }
    },
    onScroll: (scrollTop) => {
      if (typeof window.AndroidWrapper.onScroll === 'function') {
        window.AndroidWrapper.onScroll(scrollTop)
      }
    }
  } : null),

  iOS: (navigator.userAgent.includes('keel-pwa-ios') ? {
    getFcmToken: () => {
      console.info('Getting FCM token from iOS Wrapper')
      // Currently there is no way for iOS webView to return JS callback synchronously henece fcmToken will be written to localStorage directly.
      return localStorage.getItem('fcmToken')
    },
    shareContent: (shareOpts) => {
      console.info('Sharing content via iOS Wrapper')
      if (window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.shareContent &&
        window.webkit.messageHandlers.shareContent.postMessage &&
        typeof window.webkit.messageHandlers.shareContent.postMessage === 'function') {
        window.webkit.messageHandlers.shareContent.postMessage(JSON.stringify(shareOpts))
      } else {
        // Deprecate method to pass shareOpts to iOS wrapper
        window.location = 'share://' + JSON.stringify(shareOpts)
      }
    },
    setOrientation: (mode) => {
      console.info('Set orientation via iOS Wrapper')
      if (window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.setOrientation &&
        window.webkit.messageHandlers.setOrientation.postMessage &&
        typeof window.webkit.messageHandlers.setOrientation.postMessage === 'function') {
        window.webkit.messageHandlers.setOrientation.postMessage(mode ? '1' : '0')
      } else {
        console.info('Set orientation is not present in iOS Wrapper')
      }
    }
  } : null)

}
